module.exports = "/assets/2522ed12b9d9658ba151d5b01fd7fb62.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/XE.png
// module id = 1993
// module chunks = 0